import type { ComparisonLanguages, ComparisonEntry } from "../lib/types";
import { referenceKey } from "../lib/algorithms";

const RAW: ComparisonLanguages = {
  akkadian: [
    { w: "ilu", m: "god", d: "REL" }, { w: "iltu", m: "goddess", d: "REL" },
    { w: "belu", m: "lord", d: "REL" }, { w: "beltu", m: "lady", d: "REL" },
    { w: "šarru", m: "king", d: "ADM" }, { w: "šarratu", m: "queen", d: "ADM" },
    { w: "niqû", m: "offering", d: "REL" }, { w: "karābu", m: "to pray", d: "REL" },
    { w: "parāsu", m: "to divide", d: "VRB" }, { w: "nadānu", m: "to give", d: "VRB" },
    { w: "šakānu", m: "to place", d: "VRB" }, { w: "qerēbu", m: "to offer", d: "REL" },
    { w: "šumu", m: "name", d: "PER" }, { w: "amtu", m: "slave woman", d: "PER" },
    { w: "mātu", m: "land", d: "GEO" }, { w: "ālu", m: "city", d: "GEO" },
    { w: "bītu", m: "house", d: "GEO" }, { w: "ekurru", m: "temple", d: "REL" },
    { w: "šamnu", m: "oil", d: "COM" }, { w: "karānu", m: "wine", d: "COM" },
    { w: "šamašsammū", m: "sesame", d: "AGR" }, { w: "šeʾu", m: "grain", d: "AGR" },
    { w: "kirû", m: "garden", d: "AGR" }, { w: "šikaru", m: "beer", d: "COM" },
    { w: "kaspum", m: "silver", d: "COM" }, { w: "ḫurāṣu", m: "gold", d: "COM" },
    { w: "alpum", m: "ox", d: "ANI" }, { w: "immeru", m: "sheep", d: "ANI" },
    { w: "tuppu", m: "tablet", d: "ADM" }, { w: "nikkassu", m: "account", d: "ADM" },
    { w: "napḫaru", m: "total", d: "ADM" }, { w: "manû", m: "to count", d: "ADM" },
    { w: "karpatu", m: "pot", d: "VES" }, { w: "kāsu", m: "cup", d: "VES" },
    { w: "dannu", m: "jar", d: "VES" }, { w: "abu", m: "father", d: "KIN" },
    { w: "ummu", m: "mother", d: "KIN" }, { w: "māru", m: "son", d: "KIN" },
    { w: "mārtu", m: "daughter", d: "KIN" }, { w: "aḫu", m: "brother", d: "KIN" },
    { w: "rabû", m: "great", d: "ADJ" }, { w: "damqu", m: "good", d: "ADJ" },
    { w: "alāku", m: "to go", d: "VRB" }, { w: "amāru", m: "to see", d: "VRB" },
    { w: "qabû", m: "to speak", d: "VRB" }, { w: "epēšu", m: "to make", d: "VRB" },
    { w: "leqû", m: "to take", d: "VRB" }, { w: "erēbu", m: "to enter", d: "VRB" },
    { w: "libbu", m: "heart", d: "BOD" }, { w: "qātu", m: "hand", d: "BOD" },
    { w: "šēpu", m: "foot", d: "BOD" }, { w: "īnu", m: "eye", d: "BOD" },
    { w: "rēšu", m: "head", d: "BOD" }, { w: "napištu", m: "life", d: "REL" },
    { w: "ūmu", m: "day", d: "GEO" }, { w: "šattu", m: "year", d: "ADM" },
    { w: "warḫu", m: "month", d: "ADM" }, { w: "erṣetu", m: "earth", d: "GEO" },
    { w: "šamû", m: "sky", d: "GEO" }, { w: "nāru", m: "river", d: "GEO" },
    { w: "tâmtu", m: "sea", d: "GEO" }, { w: "ekallu", m: "palace", d: "ADM" },
    { w: "awīlu", m: "man", d: "PER" }, { w: "sinništu", m: "woman", d: "PER" },
  ],
  hittite: [
    { w: "šiuš", m: "god", d: "REL" }, { w: "išḫaš", m: "lord", d: "ADM" },
    { w: "ḫaššu", m: "king", d: "ADM" }, { w: "tawananna", m: "queen", d: "ADM" },
    { w: "utne", m: "land", d: "GEO" }, { w: "parna", m: "house", d: "GEO" },
    { w: "wātar", m: "water", d: "COM" }, { w: "paḫḫur", m: "fire", d: "COM" },
    { w: "tekan", m: "earth", d: "GEO" }, { w: "nepiš", m: "heaven", d: "GEO" },
    { w: "atta", m: "father", d: "KIN" }, { w: "anna", m: "mother", d: "KIN" },
    { w: "antuhšaš", m: "person", d: "PER" }, { w: "šipant", m: "to libate", d: "REL" },
    { w: "mugawar", m: "prayer", d: "REL" }, { w: "dai", m: "to place", d: "VRB" },
    { w: "ep", m: "to seize", d: "VRB" }, { w: "pēda", m: "place", d: "GEO" },
    { w: "ḫarš", m: "to plow", d: "AGR" }, { w: "wīna", m: "wine", d: "COM" },
    { w: "aiš", m: "mouth", d: "BOD" }, { w: "ešḫar", m: "blood", d: "BOD" },
    { w: "ḫaštai", m: "bone", d: "BOD" }, { w: "ed", m: "to eat", d: "VRB" },
    { w: "eku", m: "to drink", d: "VRB" }, { w: "kuen", m: "to strike", d: "VRB" },
    { w: "newa", m: "new", d: "ADJ" }, { w: "šalli", m: "great", d: "ADJ" },
    { w: "tuzzi", m: "army", d: "ADM" }, { w: "peruna", m: "rock", d: "GEO" },
    { w: "memiya", m: "word", d: "ADM" }, { w: "witt", m: "year", d: "ADM" },
  ],
  luwian: [
    { w: "maššana", m: "god", d: "REL" }, { w: "āwi", m: "to come", d: "VRB" },
    { w: "tati", m: "father", d: "KIN" }, { w: "ānni", m: "mother", d: "KIN" },
    { w: "wāna", m: "stele", d: "REL" }, { w: "tuwati", m: "to place", d: "VRB" },
    { w: "ātar", m: "self", d: "PER" }, { w: "warpa", m: "irrigation", d: "AGR" },
    { w: "parna", m: "house", d: "GEO" }, { w: "udri", m: "land", d: "GEO" },
    { w: "tarwana", m: "justice", d: "ADM" }, { w: "nani", m: "brother", d: "KIN" },
    { w: "tappaš", m: "sky", d: "GEO" }, { w: "tiyammi", m: "earth", d: "GEO" },
    { w: "ḫūḫa", m: "grandfather", d: "KIN" }, { w: "wawi", m: "cow", d: "ANI" },
    { w: "ḫawi", m: "sheep", d: "ANI" }, { w: "iziya", m: "to make", d: "VRB" },
    { w: "ura", m: "great", d: "ADJ" }, { w: "wašu", m: "good", d: "ADJ" },
  ],
  hurrian: [
    { w: "eni", m: "god", d: "REL" }, { w: "allai", m: "lady", d: "REL" },
    { w: "šarri", m: "king", d: "ADM" }, { w: "tadi", m: "to love", d: "VRB" },
    { w: "šena", m: "brother", d: "KIN" }, { w: "nera", m: "sister", d: "KIN" },
    { w: "ardi", m: "city", d: "GEO" }, { w: "abi", m: "well", d: "GEO" },
    { w: "ešše", m: "earth", d: "GEO" }, { w: "šimigi", m: "sun", d: "REL" },
    { w: "tušša", m: "army", d: "ADM" }, { w: "ewri", m: "lord", d: "ADM" },
    { w: "puru", m: "house", d: "GEO" }, { w: "kelu", m: "well-being", d: "REL" },
    { w: "šidari", m: "curse", d: "REL" }, { w: "unni", m: "to come", d: "VRB" },
    { w: "mane", m: "to be", d: "VRB" }, { w: "ar", m: "to give", d: "VRB" },
    { w: "tive", m: "word", d: "ADM" }, { w: "ḫašhari", m: "oil", d: "COM" },
    { w: "papani", m: "head", d: "BOD" }, { w: "šummi", m: "all", d: "ADJ" },
    { w: "attai", m: "father", d: "KIN" }, { w: "omini", m: "land", d: "GEO" },
    { w: "tarša", m: "person", d: "PER" }, { w: "šiye", m: "water", d: "COM" },
    { w: "ḫavurni", m: "sky", d: "GEO" }, { w: "kaži", m: "cup", d: "VES" },
    { w: "talami", m: "great", d: "ADJ" },
  ],
  ugaritic: [
    { w: "ilu", m: "god", d: "REL" }, { w: "bʿlu", m: "lord", d: "REL" },
    { w: "malku", m: "king", d: "ADM" }, { w: "malkatu", m: "queen", d: "ADM" },
    { w: "ʾarṣu", m: "earth", d: "GEO" }, { w: "šamayu", m: "heaven", d: "GEO" },
    { w: "baytu", m: "house", d: "GEO" }, { w: "yamu", m: "sea", d: "GEO" },
    { w: "ḫamru", m: "wine", d: "COM" }, { w: "šamnu", m: "oil", d: "COM" },
    { w: "ḫiṭṭu", m: "wheat", d: "AGR" }, { w: "dbḫu", m: "sacrifice", d: "REL" },
    { w: "ʾabu", m: "father", d: "KIN" }, { w: "ʾummu", m: "mother", d: "KIN" },
    { w: "binu", m: "son", d: "KIN" }, { w: "battu", m: "daughter", d: "KIN" },
    { w: "ntn", m: "to give", d: "VRB" }, { w: "yšb", m: "to dwell", d: "VRB" },
    { w: "ṯr", m: "bull", d: "ANI" }, { w: "lḥm", m: "bread", d: "COM" },
    { w: "yn", m: "wine", d: "COM" }, { w: "ksp", m: "silver", d: "COM" },
    { w: "ḫrṣ", m: "gold", d: "COM" }, { w: "špš", m: "sun", d: "REL" },
    { w: "yrḫ", m: "moon", d: "REL" }, { w: "ʾadnu", m: "lord", d: "ADM" },
    { w: "ʿbdu", m: "servant", d: "PER" }, { w: "rgm", m: "to say", d: "VRB" },
    { w: "qrt", m: "town", d: "GEO" }, { w: "gt", m: "estate", d: "AGR" },
    { w: "ʿnt", m: "Anat (goddess)", d: "REL" }, { w: "ršp", m: "Resheph (god)", d: "REL" },
  ],
  pre_greek: [
    { w: "asaminthos", m: "bathtub", d: "VES" }, { w: "labyrinthos", m: "labyrinth", d: "GEO" },
    { w: "terebinthos", m: "terebinth", d: "AGR" }, { w: "hyakinthos", m: "hyacinth", d: "AGR" },
    { w: "kyparissos", m: "cypress", d: "AGR" }, { w: "selinon", m: "celery", d: "AGR" },
    { w: "daphne", m: "laurel", d: "AGR" }, { w: "oinos", m: "wine", d: "COM" },
    { w: "elaion", m: "olive oil", d: "COM" }, { w: "tyros", m: "cheese", d: "COM" },
    { w: "plinthos", m: "brick", d: "COM" }, { w: "thalassa", m: "sea", d: "GEO" },
    { w: "nesos", m: "island", d: "GEO" }, { w: "depas", m: "cup", d: "VES" },
    { w: "pithos", m: "storage jar", d: "VES" }, { w: "askos", m: "wineskin", d: "VES" },
    { w: "larnax", m: "chest", d: "VES" }, { w: "basileus", m: "king", d: "ADM" },
    { w: "tyrannos", m: "ruler", d: "ADM" }, { w: "Knossos", m: "city", d: "GEO" },
    { w: "Phaistos", m: "city", d: "GEO" }, { w: "Amnisos", m: "harbor", d: "GEO" },
    { w: "Tylissos", m: "town", d: "GEO" }, { w: "Britomartis", m: "goddess", d: "REL" },
    { w: "Ariadne", m: "holy one", d: "REL" }, { w: "Diktynna", m: "of Dikti", d: "REL" },
    { w: "korinthos", m: "Corinth (place)", d: "GEO" }, { w: "olynthos", m: "wild fig", d: "AGR" },
    { w: "erebinthos", m: "chickpea", d: "AGR" }, { w: "narkissos", m: "narcissus", d: "AGR" },
    { w: "kissos", m: "ivy", d: "AGR" }, { w: "melissa", m: "bee", d: "ANI" },
    { w: "molybdos", m: "lead (metal)", d: "COM" }, { w: "kassiteros", m: "tin", d: "COM" },
    { w: "sesamon", m: "sesame", d: "AGR" }, { w: "minthe", m: "mint", d: "AGR" },
    { w: "Kydonia", m: "Cretan city", d: "GEO" }, { w: "Lyktos", m: "Cretan city", d: "GEO" },
    { w: "Parnassos", m: "mountain", d: "GEO" },
  ],
  proto_ie: [
    { w: "*dʰeh₁", m: "to place", d: "VRB" }, { w: "*deh₃", m: "to give", d: "VRB" },
    { w: "*steh₂", m: "to stand", d: "VRB" }, { w: "*h₁es", m: "to be", d: "VRB" },
    { w: "*dyew", m: "sky/god", d: "REL" }, { w: "*deywos", m: "god", d: "REL" },
    { w: "*ph₂ter", m: "father", d: "KIN" }, { w: "*meh₂ter", m: "mother", d: "KIN" },
    { w: "*suHnus", m: "son", d: "KIN" }, { w: "*dʰugh₂ter", m: "daughter", d: "KIN" },
    { w: "*dom", m: "house", d: "GEO" }, { w: "*h₂ger", m: "field", d: "AGR" },
    { w: "*wódr̥", m: "water", d: "COM" }, { w: "*wóyH₁nom", m: "wine", d: "COM" },
    { w: "*gʷōws", m: "cow", d: "ANI" }, { w: "*h₃owis", m: "sheep", d: "ANI" },
    { w: "*h₁reǵ", m: "king", d: "ADM" }, { w: "*meǵh₂", m: "great", d: "ADJ" },
    { w: "*néwos", m: "new", d: "ADJ" },
    { w: "*óynos", m: "one", d: "ADJ" }, { w: "*dwóh₁", m: "two", d: "ADJ" },
    { w: "*tréyes", m: "three", d: "ADJ" }, { w: "*kʷetwóres", m: "four", d: "ADJ" },
    { w: "*pénkʷe", m: "five", d: "ADJ" }, { w: "*déḱm̥", m: "ten", d: "ADJ" },
    { w: "*pṓds", m: "foot", d: "BOD" }, { w: "*ǵʰésr̥", m: "hand", d: "BOD" },
    { w: "*h₃ókʷs", m: "eye", d: "BOD" }, { w: "*ḱḗr", m: "heart", d: "BOD" },
    { w: "*nókʷts", m: "night", d: "GEO" }, { w: "*h₂stḗr", m: "star", d: "REL" },
    { w: "*bʰer", m: "to carry", d: "VRB" }, { w: "*ed", m: "to eat", d: "VRB" },
    { w: "*gʷʰen", m: "to strike", d: "VRB" },
  ],
  // Mycenaean Greek (Linear B), transliterated in the same syllabic values
  // the workbench applies to Linear A — so this is the best-calibrated of
  // the comparison sets: both sides share the syllabary's sound values.
  mycenaean: [
    { w: "wa-na-ka", m: "king (wanax)", d: "ADM" },
    { w: "qa-si-re-u", m: "chief (basileus)", d: "ADM" },
    { w: "da-mo", m: "people/community (dāmos)", d: "ADM" },
    { w: "te-o", m: "god (theos)", d: "REL" },
    { w: "po-ti-ni-ja", m: "lady/mistress (potnia)", d: "REL" },
    { w: "i-je-re-ja", m: "priestess (hiereia)", d: "REL" },
    { w: "i-je-re-u", m: "priest (hiereus)", d: "REL" },
    { w: "do-e-ro", m: "slave (doelos/doulos)", d: "PER" },
    { w: "do-e-ra", m: "female slave", d: "PER" },
    { w: "ko-wo", m: "boy/son (korwos)", d: "KIN" },
    { w: "ko-wa", m: "girl/daughter (korwā)", d: "KIN" },
    { w: "a-ni-ja", m: "reins", d: "COM" },
    { w: "to-so", m: "so much/total (tosos)", d: "ADM" },
    { w: "to-sa", m: "so many (fem.)", d: "ADM" },
    { w: "o-pe-ro", m: "deficit/owing (ophelos)", d: "ADM" },
    { w: "pa-ro", m: "from/beside (paro)", d: "ADM" },
    { w: "e-ke", m: "he has (ekhei)", d: "VRB" },
    { w: "di-do-si", m: "they give (didonsi)", d: "VRB" },
    { w: "do-ke", m: "he gave (dōke)", d: "VRB" },
    { w: "e-ko-si", m: "they have (ekhonsi)", d: "VRB" },
    { w: "wa-tu", m: "town (wastu)", d: "GEO" },
    { w: "po-ro", m: "foal (pōlos)", d: "ANI" },
    { w: "i-qo", m: "horse (hiqqos)", d: "ANI" },
    { w: "po-me", m: "shepherd (poimēn)", d: "PER" },
    { w: "ke-ra-me-u", m: "potter (kerameus)", d: "PER" },
    { w: "ka-ke-u", m: "smith (khalkeus)", d: "PER" },
    { w: "te-ko-to-ne", m: "carpenters (tektones)", d: "PER" },
    { w: "ka-ko", m: "bronze (khalkos)", d: "COM" },
    { w: "ku-ru-so", m: "gold (khrusos)", d: "COM" },
    { w: "e-ra-wo", m: "olive oil (elaiwon)", d: "COM" },
    { w: "wo-no", m: "wine (woinos)", d: "COM" },
    { w: "me-ri", m: "honey (meli)", d: "COM" },
    { w: "tu-ro", m: "cheese (tūros)", d: "COM" },
    { w: "ko-no", m: "rush/reed", d: "AGR" },
    { w: "si-to", m: "grain (sitos)", d: "AGR" },
    { w: "ze-u-ke-si", m: "yokes/pairs (zeugesi)", d: "ADM" },
    { w: "we-to", m: "year (wetos)", d: "ADM" },
    { w: "a-ke-ro", m: "messenger (angelos)", d: "PER" },
    { w: "te-re-ta", m: "official (telestās)", d: "ADM" },
    { w: "ra-wa-ke-ta", m: "war-leader (lāwāgetās)", d: "ADM" },
    { w: "e-re-ta", m: "rower (eretās)", d: "PER" },
    { w: "ka-ma", m: "plot of land", d: "AGR" },
    { w: "ki-ti-me-na", m: "cultivated (land)", d: "AGR" },
    { w: "te-me-no", m: "domain/precinct (temenos)", d: "GEO" },
    { w: "di-pa", m: "cup (depas)", d: "VES" },
    { w: "pa-ka-na", m: "swords (phasgana)", d: "COM" },
    { w: "to-ra-ke", m: "corslets (thōrākes)", d: "COM" },
    { w: "ko-to-na", m: "plot of land (ktoinā)", d: "AGR" },
    { w: "a-ne-mo", m: "winds (anemoi)", d: "REL" },
    { w: "di-wo", m: "Zeus (gen.)", d: "REL" },
    { w: "e-ra", m: "Hera", d: "REL" },
    { w: "po-se-da-o", m: "Poseidon", d: "REL" },
  ],
  egyptian: [
    { w: "nṯr", m: "god", d: "REL" }, { w: "nṯrt", m: "goddess", d: "REL" },
    { w: "nsw", m: "king", d: "ADM" }, { w: "ḥqꜣ", m: "ruler", d: "ADM" },
    { w: "pr", m: "house", d: "GEO" }, { w: "tꜣ", m: "land", d: "GEO" },
    { w: "mw", m: "water", d: "COM" }, { w: "jrp", m: "wine", d: "COM" },
    { w: "mrḥt", m: "oil", d: "COM" }, { w: "jt", m: "barley", d: "AGR" },
    { w: "bdt", m: "wheat", d: "AGR" }, { w: "jt", m: "father", d: "KIN" },
    { w: "mwt", m: "mother", d: "KIN" }, { w: "sꜣ", m: "son", d: "KIN" },
    { w: "rdj", m: "to give", d: "VRB" }, { w: "jrj", m: "to make", d: "VRB" },
    { w: "ḥtp", m: "offering", d: "REL" }, { w: "wdnw", m: "libation", d: "REL" },
    { w: "sṯj", m: "to pour", d: "REL" }, { w: "Kftjw", m: "Keftiu/Crete", d: "GEO" },
    { w: "rmṯ", m: "people", d: "PER" }, { w: "sḏm", m: "to hear", d: "VRB" },
    { w: "mꜣꜣ", m: "to see", d: "VRB" }, { w: "ꜥnḫ", m: "to live", d: "REL" },
    { w: "jb", m: "heart", d: "BOD" }, { w: "ḏrt", m: "hand", d: "BOD" },
    { w: "jrt", m: "eye", d: "BOD" }, { w: "rꜥ", m: "sun (Ra)", d: "REL" },
    { w: "jꜥḥ", m: "moon", d: "REL" }, { w: "hrw", m: "day", d: "GEO" },
    { w: "grḥ", m: "night", d: "GEO" }, { w: "nb", m: "lord", d: "ADM" },
    { w: "ḥmt", m: "woman", d: "PER" }, { w: "ẖrd", m: "child", d: "KIN" },
    { w: "jḥ", m: "ox", d: "ANI" }, { w: "ḥnqt", m: "beer", d: "COM" },
    { w: "ꜣst", m: "Isis (goddess)", d: "REL" }, { w: "wsjr", m: "Osiris (god)", d: "REL" },
  ],
};

function precomputePhonetic(entries: ComparisonEntry[]): ComparisonEntry[] {
  return entries.map((e) => ({
    ...e,
    // Strip reconstruction/notation marks AND hyphens so the comparison key
    // is a bare concatenated phonetic string — matching the Linear A side,
    // where wordToPhonetic joins syllables without separators (KU-RO →
    // "kuro"). This is what makes Mycenaean (wa-na-ka → "wanaka") compare
    // fairly. Stripped: the reconstruction asterisk, PIE laryngeal subscripts
    // (₁₂₃), the labialization/aspiration modifier letters (ʰ ʷ), the
    // combining syllabic ring below (U+0325, as in r̥ l̥ n̥), and hyphens.
    // Note we deliberately do NOT strip the glottal/pharyngeal letters
    // (ʾ ʿ ꜣ ꜥ) — those are segmental and left to score on their own.
    p: referenceKey(e.w, true),
  }));
}

export const COMPARISON_LANGUAGES: ComparisonLanguages = Object.fromEntries(
  Object.entries(RAW).map(([k, v]) => [k, precomputePhonetic(v)]),
);

// Human-readable labels for the built-in comparison languages. The data keys
// are bare identifiers (snake_case); the UI shows these instead. Custom
// languages added via the Wordlist Manager fall back to their raw key.
export const LANGUAGE_LABELS: Record<string, string> = {
  akkadian: "Akkadian",
  hittite: "Hittite",
  luwian: "Luwian",
  hurrian: "Hurrian",
  ugaritic: "Ugaritic",
  pre_greek: "Pre-Greek substrate",
  proto_ie: "Proto-Indo-European",
  mycenaean: "Mycenaean Greek (Linear B)",
  egyptian: "Egyptian",
};

export function languageLabel(key: string): string {
  return LANGUAGE_LABELS[key] ?? key;
}
